module.exports = __webpack_public_path__ + "img/7.5b5ee6d6.png";